import { useIntl } from 'react-intl';

import EmptyIcon from '@/assets/icons/empty-campaigns.svg';
import { EmptyState } from '@/components/ui/empty-state';

interface NoOpeningsProps {
  // When set, the table is empty because a search returned no matches, not
  // because there are no openings at all — surface a search-specific message.
  searchQuery?: string;
}

export function NoOpenings({ searchQuery }: NoOpeningsProps) {
  const intl = useIntl();

  if (searchQuery) {
    return (
      <EmptyState
        header={intl.formatMessage(
          {
            defaultMessage: "No results for ''{searchQuery}''",
            description:
              'Openings search returned no matching openings; {searchQuery} is the text the user typed',
          },
          { searchQuery },
        )}
        description={intl.formatMessage({
          defaultMessage: 'Try a different opening name.',
          description: 'Suggests the user adjust their openings search term',
        })}
      />
    );
  }

  return (
    <EmptyState
      icon={EmptyIcon}
      header={intl.formatMessage({
        defaultMessage: 'No openings to show',
        description:
          'Openings list empty: filters or permissions returned zero rows',
      })}
      description={intl.formatMessage({
        defaultMessage: 'There are no openings to show at the moment.',
        description:
          'Reassure user the empty state is temporary or filter-driven',
      })}
    />
  );
}
